module.exports = __webpack_public_path__ + "img/pose-m-5.e763389b.png";